import {css} from 'styled-components'
import {Colors} from '../../theme/colours'

export const FocusOutlineCss = css`
    // I think its fine if everything
    // uses this color as its meant to provide
    // visiblity to the user what is currently
    // focused.
    outline: 2px solid #1f88e5;
    outline-offset: 2px;
`

export const KeyboardFocusOutline = css`
    // Each react-aria element will have this exact
    // data attribute set on it, if
    // its currently focused using the keyboard.
    &[data-focus-visible] {
        ${FocusOutlineCss}
    }
`

export const FocusBorderCss = css`
    // We don't want border width cause some element might
    // not have border
    border-color: #1f88e5;
`

export const KeyboardFocusBorder = css`
    &[data-focus-visible] {
        ${FocusBorderCss}
    }
`

export const ErrorBorderCss = css`
    border: 2px solid ${(props) => props.theme.colors.text.error};
    border-radius: 4px;
`

export const DefaultBorderCss = css`
    border: 2px solid ${Colors.grey16};
    border-radius: 4px;
`

export const TruncatedTextCss = css`
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
`
